module.exports = __webpack_public_path__ + "img/lesserDust.79cddbf0.png";